import { EVENT_FRONTEND_PARAMS, TOURNAMENT_STAGES_STATES_KEY } from '@/modules/UserEventLanding/constants';
import i18n from '@/plugins/I18n';
import InfoStage from './info-stages/index';

export const EVENT_NOMINATIONS_OVERRIDES = {
  NOMINATIONS: 'nominations',
  SECTIONS: 'sections',
  TRACKS: 'tracks',
  TOPICS: 'topics',
  SITES: 'sites',
  CATEGORIES: 'categories',
  DIRECTIONS: 'directions',
  DISCIPLINES: 'disciplines',
};

const DEFAULT_OVERLAY_IMAGE_COLOR = {
  overlay: '#F1F2F6CC',
  text: '#212121',
};

export default class FrontendParams {
  constructor(item) {
    this.image_overlay = item.image_overlay || { ...DEFAULT_OVERLAY_IMAGE_COLOR };

    const overrideItem = typeof item.nominations_override === 'string' ? {
      key: 'nominations_override',
      value: item.nominations_override,
    } : {
      key: 'nominations_override',
      value: EVENT_NOMINATIONS_OVERRIDES.NOMINATIONS,
      ...item.nominations_override,
    };
    this.nominations_override = {
      key: overrideItem?.key || 'nominations_override',
      value: typeof (overrideItem?.value?.value || overrideItem?.value) !== 'object'
        ? overrideItem?.value?.value || overrideItem?.value
        : EVENT_NOMINATIONS_OVERRIDES.NOMINATIONS,
    };

    this.many_event_stages = item.many_event_stages || null;

    this.event_managers = item.event_managers || [];

    this.event_user_requirements = item.event_user_requirements || { is_per_nominations: false };

    /**
     *  Key - vote_id
     *  Record<string, { nomination: number; stage: number; poll: number }>;
     */
    this.poll_work_filters = item.poll_work_filters || null;

    this[EVENT_FRONTEND_PARAMS.TOURNAMENT_STAGES_STATE] = item[EVENT_FRONTEND_PARAMS.TOURNAMENT_STAGES_STATE] || TOURNAMENT_STAGES_STATES_KEY.one;
    // this[EVENT_FRONTEND_PARAMS.TOURNAMENT_STAGES_STATE] = item[EVENT_FRONTEND_PARAMS.TOURNAMENT_STAGES_STATE] || TOURNAMENT_STAGES_STATES_KEY.unset;
    this[EVENT_FRONTEND_PARAMS.INFO_STAGES] = (item[EVENT_FRONTEND_PARAMS.INFO_STAGES] || []).map((i) => new InfoStage(i));
  }

  /**
   * @param {String} key - object key
   * @param {Null | Number | Object} countOptions - Count or Object of count options;
   *  when Object, has {
   *    count?: Number | Null,
   *    pluralization?: String (if '' then disable pluralization),
   *    valueKey?: String (value key for getting name from param key)
   *  }
   * @returns String
   */
  getEntityName(key, countOptions = null) {
    const defaultValueKey = 'value';
    const defaultPluralizationValue = 'default';
    const defaultCountedPluralization = 'counted';

    const valueKey = countOptions?.valueKey || defaultValueKey;

    if (!(this[key] && this[key][valueKey])) return '';

    const defaultPluralization = countOptions?.pluralization ?? defaultPluralizationValue;
    const countedPluralization = countOptions?.pluralization ?? defaultCountedPluralization;

    const count = countOptions?.count || countOptions || null;

    const isCounted = typeof count === 'number';
    const pluralizationType = isCounted ? countedPluralization : defaultPluralization;
    const isDisabledPluralization = !defaultPluralization || !countedPluralization;

    const textPath = ['user_event_landing', key, ...(isDisabledPluralization ? [] : [pluralizationType]), this[key][valueKey]].join('.');

    const params = [textPath, ...(isCounted ? [count] : [])];

    return i18n.tc(...params);
  }

  get mainImageOverlayColor() {
    const { overlay, text } = this.image_overlay || {};
    return overlay && text ? { overlay, text } : { ...DEFAULT_OVERLAY_IMAGE_COLOR };
  }
}
